import { ZfBox } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import type { TopicDto } from '../../../api/generated/client';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { useContainerDimensions } from '../../../hooks/useContainerDimensions';
import { buildPanelProps } from '../../../utils/topicUtils';
import { TopicPanel } from '../panels/TopicPanel';
import { TopicScreenPresentationSideBar } from './TopicScreenPresentationSideBar';

export const TopicScreenPresentation: FunctionComponent = () => {
    const containerDimensions = useContainerDimensions();
    const { activeTopic, activeTalkingPoint, activeAdvisoryNeed } = useNeedContentContext();
    const navigate = useNavigate();

    return (
        <ZfBox id="topicScreen" style={{ flex: 1 }}>
            <div className="topic-screen" style={{ height: `${containerDimensions.height}px` }}>
                <TopicScreenPresentationSideBar topic={activeTopic} goBack={() => navigate('..')} />
                <div className="topic-screen__panels presentation">
                    <TopicPanel {...buildPanelProps(activeTopic as TopicDto, containerDimensions.height, activeTalkingPoint, activeAdvisoryNeed, true, true)} />
                </div>
            </div>
        </ZfBox>
    );
};
